/**
 * @file: 层板商品贴边均匀算法
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import FrontCubeData from '../../frontCubeData/index';
import Utils from '../../utils/util';
import { layerLink } from '../../interaction/layerGroup/link';
import { hasFoldGoods, hasMoreSurface, diffWidthMainAndSub } from '../goods/index';
import { cubeCountInLayer, layerIsGrouped, layerCubesTotalWidth, layersTotalWidth } from './layerInfo';
import { cubeModify } from '../../update/cubeModify';
import { layerCubeSizeContainSpace } from '../size/index';

export default function spaceBetween(layoutTask: Array<LayoutTask>): void {
    layoutTask.forEach((task: LayoutTask): void => {
        let spaceTotalWidth: PhysicsMeasurement = layerSpaceWidth(task.layerId);
        let grouped: boolean = layerIsGrouped(task.layerId);

        layout(task.layerId, spaceTotalWidth);
    });
}

function layout(layer: CubeId, spaceTotalWidth: PhysicsMeasurement): void {
    let layoutCubeIds: CubeId[] = findLayoutCubeIds(layer);
    let layerChildren: CubeId[] = CubeTree.findChildCubeIds(layer);
    let count: number = cubeCountInLayer(layoutCubeIds);
    let spaceAroundWidth: PhysicsMeasurement = Toolkit.spaceBetweenWidth({
        spaceTotal: spaceTotalWidth,
        moduleTotalWidth: layerCubesTotalWidth(layoutCubeIds),
        moduleCount: count
    });
    let startPos: PhysicsMeasurement = startLeftCompute(layer, spaceAroundWidth);

    layerChildren.forEach((cubeId: CubeId): void => {
        // 商品中存在叠放商品，此种情况干掉商品中的间隔
        if (hasFoldGoods(cubeId)) {
            cubeModify(cubeId, {
                posWidth: 0
            });
        }

        // 商品中不存在叠放商品，且是多面宽，则给商品加间距
        else if (hasMoreSurface(cubeId)) {
            // 最宽字码和主码的宽度差，用来补齐posWidth
            let diffWidth: PhysicsMeasurement = diffWidthMainAndSub(cubeId);

            cubeModify(cubeId, {
                posWidth: Utils.toFixedNumber(spaceAroundWidth + diffWidth, 2)
            });
        }

        let layoutCubeSize: PhysicsSize = layerCubeSizeContainSpace(cubeId);

        /**
         * todo:
         * 1. specialAttr设置
         * 2. 隔板
         */
        startPos = Utils.toFixedNumber(startPos, 2);
        cubeModify(cubeId, {
            posX: startPos,
            posY: 0
        });
        startPos += layoutCubeSize.width + spaceAroundWidth;
    });
}

// 起始坐标计算
function startLeftCompute(layerId: CubeId, spaceAroundWidth: PhysicsMeasurement): PhysicsMeasurement {
    let extendLeft: PhysicsMeasurement = FrontCubeData.getNumberValue(layerId, 'extendLeft');
    let link: LinkedListInstance|null = layerLink(layerId);

    return -extendLeft;
}

function findLayoutCubeIds(layerId: CubeId): CubeId[] {
    return CubeTree.findChildCubeIds(layerId);
}

function layerSpaceWidth(layerId: CubeId): PhysicsMeasurement {
    let grouped: boolean = layerIsGrouped(layerId);
    let result: PhysicsMeasurement = 0;
    let moduleWidth: number = FrontCubeData.getNumberValue(layerId, 'moduleWidth');
    let extendLeft: PhysicsMeasurement = FrontCubeData.getNumberValue(layerId, 'extendLeft');
    let extendRight: PhysicsMeasurement = FrontCubeData.getNumberValue(layerId, 'extendRight');

    result = Utils.math(extendLeft, moduleWidth, '+');
    result = Utils.math(result, extendRight, '+');

    return result;
}
